"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _shared = require("./shared");

var _controls = require("./controls");

var _plugins = require("../constants/plugins");

var _file = require("../utils/file");

var _Content = require("../api/Content");

var _FileManager = require("../api/FileManager");

var _anchor = require("../utils/anchor");

function linkPlugin(editor) {
  var _editor$settings = editor.settings,
      apiClient = _editor$settings.apiClient,
      scopes = _editor$settings.scopes;
  (0, _controls.addControls)((0, _extends2.default)({
    editor: editor,
    onSelectFile: (0, _file.getInsertFileHandler)(editor),
    fetchPages: function fetchPages(term, offset) {
      return (0, _Content.fetchContentPageList)(term, offset, apiClient, scopes);
    },
    onChangeLink: function onChangeLink(linkOptions) {
      (0, _shared.onLinkUpdate)(editor, linkOptions);
    },
    fetchPageBySlug: function fetchPageBySlug(slug) {
      return (0, _Content.fetchPageBySlug)(slug, apiClient, scopes);
    },
    fetchFileFromUrl: function fetchFileFromUrl() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _FileManager.checkForFile.apply(void 0, args.concat([apiClient]));
    },
    fetchMeetings: function fetchMeetings() {
      return (0, _Content.fetchMeetingList)(apiClient);
    },
    fetchMeetingBySlug: function fetchMeetingBySlug(slug) {
      return (0, _Content.fetchMeetingBySlug)(slug, apiClient);
    },
    fetchAnchors: function fetchAnchors(anchorId) {
      return (0, _anchor.fetchAnchorsOnPage)(editor, anchorId);
    }
  }, (0, _shared.getPopoverLinkSettings)(editor)));
}

_tinymce.default.PluginManager.add(_plugins.HS_LINK, linkPlugin);